import React, {Component} from "react";
import Util from "../../utils/utils";
import {Redirect} from "react-router-dom";
import axios from "axios";
import * as config from "../../config";
import ErrorModal from "../../components/layout/modal/error";
import ButtonLoader from "../../components/form/Button/Button";
import $ from "jquery";

class Profile extends Component {

    async updateEmail(email) {
        const token = "Bearer " + Util.getSession( "token" );
        let bodyFormData = new FormData();

        bodyFormData.append('email', email);

        return await axios.post(config.api_url + "/account/email", bodyFormData, {
            timeout: 30000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : token,
            }
        })
    }

    constructor(props) {
        super(props);

        this.state = {
            error: null,
            isLoaded: false,
            status: 200,
            errorShow: false,
            items: null,
            email: null,
        };

    }

    async CheckToken(token) {
        try {
            const res = await axios.post(`${config.api_url}/account/refresh-token`, {}, {
                timeout: 30000,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token,
                }
            });

            if (res.data.status) {
                Util.setSession("token", res.data.token);
                this.setState((oldstate) => ({...oldstate, showVerify: true}))
            }

            const newToken = `Bearer ${Util.getSession("token")}`;
            this.mainData(newToken);

        } catch (error) {
            this.setState({error, isLoaded: true});
        }
    }

    async mainData(token) {
        try {
            const res = await axios.post(`${config.api_url}/account/me`, {}, {
                timeout: 30000,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token,
                }
            });

            if (res.data.status) {
                this.setState({
                    isLoaded: true,
                    status: 200,
                    items: res.data.data, // Assuming res.data.data contains the data you want to display
                    email: res.data.data.email
                });
            } else {
                this.setState({
                    isLoaded: true,
                    status: 401,
                    error: {}
                });
            }

        } catch (error) {
            this.setState({
                isLoaded: true,
                status: 401,
                error
            });
        }
    }

    async componentDidMount() {
        const token = `Bearer ${Util.getSession("token")}`;
        this.CheckToken(token);

        $("#phoneNumber").on('input', function () {
            let val = $(this).val();

            $(this).val(Util.convertNumber(val, "fa"));
        });

        $("#email").on('input', function () {
            let val = $(this).val();

            $(this).val(Util.convertNumber(val, "en"));
        });
    }

    componentDidUpdate() {
        Util.convertNumberToPersion(document.body);
    }

    handleRefresh = () => {
        this.setState((oldstate) => ({...oldstate, errorShow: false}));
        window.location.reload();
    };

    render() {
        const token = Util.getSession("token");

        if (!token)
            return <Redirect to="/login"/>;

        const {error, isLoaded, items} = this.state;

        if (error) {
            return (
                <ErrorModal
                    show={true}
                    handleRefresh={this.handleRefresh}
                    title="خطا!"
                    buttonStatus={true}
                    message="در دریافت اطلاعات مشکلی به وجود آمده است!"
                    style={{
                        "color": "red",
                        "fontSize": "50px"
                    }}
                    iconName="fa-close"/>
            );
        } else if (!isLoaded) {
            return (
                <ErrorModal
                    show={true}
                    handleRefresh={this.handleRefresh}
                    title="لطفا منتظر بمانید"
                    buttonStatus={false}
                    message="در حال دریافت اطلاعات ..."
                    style={{
                        "color": "white",
                        "fontSize": "50px"
                    }}
                    iconName="fa-refresh fa-spin"/>
            );
        } else {
            const handleSubmit = async () => {
                if (this.state.email && items.email !== this.state.email) {
                    let email = this.state.email;

                    let response = await this.updateEmail(
                        email
                    );

                    if (response.data.status) {
                        Util.setSession("email", email);
                        return false

                    } else {
                        let error = "";

                        response.data.error.map(value => {
                            return error += value + "\n";
                        });

                        this.setState((oldState) => ({
                            ...oldState,
                            toastShow: true,
                            toastMessage: error
                        }));
                    }
                }
            };

            this.componentDidUpdate();

            return (

                <div className="col-12 m-0 p-0">
                    <div className="row profile-card mb-5 mt-5">
                        <p className="profile-title">
                            حساب کاربری
                        </p>
                        <form className="row profile-form" onSubmit={(e) => e.preventDefault()}>
                            <label className="profile-form-label" htmlFor="phoneNumber">شماره همراه</label>
                            <div className="d-flex w-100 justify-content-center">
                                <input
                                    disabled={true}
                                    tabIndex="2"
                                    className="profile-form-input"
                                    minLength="10"
                                    maxLength="10"
                                    type="tel"
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    placeholder={items.phone_number}/>
                            </div>
                            <label className="profile-form-label" htmlFor="email">ایمیل</label>
                            <div className="d-flex w-100 justify-content-center">
                                <input
                                    tabIndex="2"
                                    className="profile-form-input"
                                    type="email"
                                    id="email"
                                    name="email"
                                    placeholder="لطفا ایمیل خود را وارد کنید"
                                    value={this.state.email}
                                    onInput={e => this.setState((oldState) => ({
                                        ...oldState,
                                        email: e.target.value
                                    }))}
                                />
                            </div>
                            <ButtonLoader
                                tabIndex="3"
                                loadingTxt="درحال دریافت اطلاعات"
                                normalTxt="ذخیره"
                                handleData={handleSubmit}
                            />
                        </form>
                    </div>
                </div>

            );
        }
    }
}

export default Profile;